import React, { useEffect, useState } from 'react';
import './Indicator.css';

import { ReactComponent as TrafficOk } from '../../assets/icons/traffic_ok.svg';
import { ReactComponent as TrafficError } from '../../assets/icons/traffic_error.svg';

const TOOLTIP_SIZE = { width: 260, height: 64, margin: 12 };

const getTooltipPosition = (clientX, clientY) => {
  if (typeof window === 'undefined') {
    return { x: clientX, y: clientY };
  }

  return {
    x: Math.min(
      Math.max(TOOLTIP_SIZE.margin, clientX + 12),
      window.innerWidth - TOOLTIP_SIZE.width - TOOLTIP_SIZE.margin
    ),
    y: Math.min(
      Math.max(TOOLTIP_SIZE.margin, clientY + 12),
      window.innerHeight - TOOLTIP_SIZE.height - TOOLTIP_SIZE.margin
    ),
  };
};

const Indicator = ({site, className = ''}) => {
  const [tooltipPosition, setTooltipPosition] = useState(null);
  const [tooltipText, setTooltipText] = useState('Traffic status unavailable');
  const status = site?.status || null;

  const getIcon = (color) => {
    switch (color) {
    case 'red':
    case 'orange':
      return <TrafficError className="icon base status-indicator__icon" />;
    case 'green':
      return <TrafficOk className="icon base status-indicator__icon" />;
    default:
      return null;
    }
  };

  useEffect(() => {
    if (status === 'green') {
      setTooltipText('Traffic received in the past three hours');
    } else if (status === 'orange') {
      setTooltipText('No traffic detected in the past three hours');
    } else if (status === 'red') {
      setTooltipText('No traffic received');
    }
  }, [status]);

  return (
    <div className={`status-indicator ${className}`.trim()}
         onMouseEnter={(e) => {
           setTooltipPosition(getTooltipPosition(e.clientX, e.clientY));
         }}
         onMouseLeave={() => setTooltipPosition(null)}
         onMouseMove={(e) => setTooltipPosition(getTooltipPosition(e.clientX, e.clientY))}
         onTouchStart={(e) => {
           const touch = e.touches[0];
           if (touch) setTooltipPosition(getTooltipPosition(touch.clientX, touch.clientY));
         }}
         onTouchEnd={() => setTooltipPosition(null)}>
      {tooltipPosition && (
        <div className="tooltip tooltip-floating"
             style={{ left: tooltipPosition.x,
                      top: tooltipPosition.y }}>
          {tooltipText}
        </div>
      )}
      {getIcon(status)}
    </div>
  );
};

export default Indicator;
